import React, { useEffect, useState } from "react";
import "./App.css";
import Map from "./components/Map.js";
import Places from "./components/Places.js";
// this comment tells babel to convert jsx to calls to a function called jsx instead of React.createElement
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import axios from "axios";
import { useScroll } from "./hooks";
import _ from "lodash";
import Gallery from "./components/Gallery.js";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import { useMediaQuery } from 'react-responsive';

//CSS
const styled = {
  layout: css`
    display: flex;
    gap: 20px;
    max-width: 920px;
    margin: 0 auto 0 auto;

    @media screen and (max-width: 800px) {
      display: block;
    }
  `,
  places: css`
    width: 40vw;

    @media screen and (max-width: 800px) {
      min-width: 80%;
      margin: 0 auto;
      padding-top: 5px;
    }

    @media screen and (max-width: 480px) {
      min-width: 97%;
    }
  `,
  map: css`
    width: 100%;
    height: 400px;
    position: relative;
  `,
  mapContainer: css`
    position: sticky;
    width: 60vw;
    height: 400px;
    right: 0;
    top: 150px;
    z-index: 1;

    @media screen and (max-width: 800px) {
      width: 100%;
      height: 250px;
      top: 58px;
    }
  `,
  extensions: css`
    background-color: gray;
    height: 200px;
    position: relative;
  `,
};

function App() {
  const [data, setData] = useState([]);
  const [extension, setExtension] = useState("Hi, I'm the default");
  const [lng, setLng] = useState(-76.2484399374174);
  const [lat, setLat] = useState(44.9000180934008);
  const [zoom, setZoom] = useState(4);
  const [pitch, setPitch] = useState(22);
  const [layerID, setLayerID] = useState("0");
  const [activePlaceID, setActivePlaceID] = useState();
  const [bounds, setBounds] = useState(null);
  const [showExtensions, setshowExtensions] = useState(true);
  const [icons, setIcons] = useState();
  const [gallery, setGallery] = useState();
  const [markers, setMarkers] = useState();
  // const [CTA, setCTA] = useState();
  const [inProp, setInProp] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const isMobile = useMediaQuery({ query: `(max-width: 800px)` });
  const [offsetTop, setOffsetTop] = useState(250)

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const result = await axios("https://ontario.app/api/placesetter");
  //     console.log(result.data);
  //     setData(
  //       result.data.map((data) => {
  //         return {
  //           nid: data.nid[0].value,
  //           title: data.field_name[0].value,
  //           description: data.field_description[0].value,
  //           geo: JSON.parse(data.field_route_path_geojson[0].value),
  //           lng: data.field_location[0].lng,
  //           lat: data.field_location[0].lat,
  //         };
  //       })
  //     );
  //   };
  //   fetchData();
  // }, []);

  useEffect(() => {
    if(isMobile) {
      setOffsetTop(500)
    }
    else {
      setOffsetTop(250)
    }
  }, [isMobile])

  //Get Data
  useEffect(() => {
    const fetchData = async () => {
      // const result = await axios(
      //   "https://api.airtable.com/v0/appa9vP98zg4hk3ng/tblMnAJ5t7CDd2IWW?api_key=key1X1S9aJMJq7SUC&view=Grid%20view"
      // );

      var Airtable = require("airtable");
      var base = new Airtable({
        apiKey:
          "patlvLkaeYd76UiIi.9b0eda5d0862b5954687a75677a4aee0dc8f61a047f12fdc56b59cc33a57812c",
      }).base("appa9vP98zg4hk3ng");

      const results = base("OHTO FlyBy")
        .select({
          view: "Grid view",
        })
        .firstPage(function (err, records) {
          if (err) {
            console.error(err);
            return;
          }
          const d = records;

          let iconJSON = [];

          setData(
            d?.map((data) => {
              let icons = [];
              //Calculate Icons
              if (!_.isEmpty(data.fields.icons)) {
                let iconJSON = data.fields.icons.map((icon, index) => {
                  return {
                    type: "Feature",
                    properties: {
                      imageUrl: icon.url,
                      iconSize: [50, 50],
                    },
                    geometry: {
                      type: "Point",
                      coordinates: JSON.parse(data.fields.icon_pos)[index],
                    },
                  };
                });
                icons.push(createMarkers(iconJSON));
              }

          return {
            nid: data.id,
            title: data.fields.name,
            description: data.fields.copy,
            geo: data.fields.geojson ? JSON.parse(data.fields.geojson) : {},
            lng: data.fields.lng,
            lat: data.fields.lat,
            zoomLevel: data.fields.zoomLevel,
            pitch: data.fields.pitch,
            icons: icons,
            extension: data.fields.extension,
            // image_gallery: data.fields.image_gallery,
            image_gallery: data.fields.image_gallery ? data.fields.image_gallery[0].thumbnails.large : {},
            CTA: data.fields.cta ? JSON.parse(data.fields.cta) : {},
          };
        })
      );
        });
    };
    fetchData();
  }, []);

  //Create Icons
  // ADD MARKERS TO MAP
  function createMarkers(geojson) {
    return geojson.map((marker) => {
      const svgMarker = renderMarker(marker);
      // To get an actual DOM node instead of a string we append our marker to a dummy element and query it again with 'firstchild'. This way we retrieve a normal DOM node
      const placeholder = document.createElement("div");
      placeholder.innerHTML = svgMarker;
      const el = placeholder.firstChild;
      return new mapboxgl.Marker(el.nextSibling).setLngLat(
        marker.geometry.coordinates
      );
    });
  }
  //Render Marker Helper Function
  function renderMarker(marker) {
    const { imageUrl } = marker.properties;
    return `
<div>
            <svg class="e-marker" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 342 232" width="70">
                <image class="e-marker__image" width="342px" height="232px" clip-path="url(#circle)" xlink:href="${imageUrl}" />
</svg>
</div>
   
    `;
  }

  //Apply Data from first Place
  useEffect(() => {
    if (!_.isEmpty(data)) {
      if (data[0].lat && data[0].lng && data[0].pitch && data[0].zoomLevel) {
        setLng(data[0].lng);
        setLat(data[0].lat);
        setZoom(data[0].zoomLevel);
        setPitch(data[0].pitch);
      }
    }
  }, [data]);

  useScroll(() => {
    const scrollPosition = window.scrollY;
    // if (scrollPosition > 10) {
    //   setExtension("I'm a change of zoom");
    //   setZoom(6);
    // }
    // if (scrollPosition > 20) {
    //   setExtension("I'm a change of pitch");
    //   // setZoom(7);
    //   // setPitch(30);
    //   setLayerID("15450");
    // }

    const allTeasers = document.querySelectorAll(".place-teaser");

    allTeasers.forEach((place, index) => {
      const nid = place.id;
      const { y: nodeY, height: cardHeight } = place.getBoundingClientRect();
      // const offsetTop = 250;
      if (nodeY <= offsetTop && nodeY >= offsetTop - cardHeight) {
        //Stop card is in scroll view
        setLayerID(nid);
        setActiveIndex(index);

        let foundData = data.find((element) => element.nid === nid);
        if (index === allTeasers.length - 1) {
          setshowExtensions(false);
        }

        if (!_.isEmpty(foundData.image_gallery)) {
          setGallery(foundData.image_gallery);
        } else {
          setGallery([]);
        }

        // setLng(foundData.lng);
        // setLat(foundData.lat);
        // setPitch(55);
        // setPitch(55);

        if (
          foundData.lat &&
          foundData.lng &&
          foundData.pitch &&
          foundData.zoomLevel
        ) {
          setLng(foundData.lng);
          setLat(foundData.lat);
          setZoom(foundData.zoomLevel);
          setPitch(foundData.pitch);
        }

        if (!_.isEmpty(foundData.CTA)) {
          // setCTA({ cta: foundData.CTA, id: foundData.nid });
          setInProp(true);
        } else {
          // setCTA();
        }

        if (!_.isEmpty(foundData.geo)) {
          setBounds(foundData.geo);
        }

        if (!_.isEmpty(foundData.icons)) {
          setIcons(foundData.icons);
        } else {
          setIcons([]);
        }
      }
    });
  }, 100);

  return (
    <div className="App" css={styled.layout}>
      <div css={styled.mapContainer}>
        <div css={styled.map}>
          {data.length > 0 && (
            <Map
              data={data}
              lat={lat}
              lng={lng}
              pitch={pitch}
              zoom={zoom}
              layerID={layerID}
              bounds={bounds}
              icons={icons}
              inProp={inProp}
            />
          )}
        </div>
        {/*<Gallery images={gallery} />*/}
      </div>
      <div css={styled.places}>
        <Places
          data={data}
          // CTA={CTA}
          extension={data.extension}
          activeIndex={activeIndex}
        />
      </div>
    </div>
  );
}

export default App;
